import VideoEditorControl from './video-editor-control'
import VideoEditorCropControl from './video-editor-crop-control'
import VideoEditorTrimControl from './video-editor-trim-control'

export default {
    VideoEditorControl,
    VideoEditorCropControl,
    VideoEditorTrimControl
}
